var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-button-group"},_vm._l((_vm.elements),function(element,index){return _c('baseradiobutton',{key:element,class:_vm.calculatedClass,attrs:{"option":index + 1,"title":_vm.$t(_vm.translationKey + element)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }